import columns from '../../../../../../react-table/helpers/columns';
import { sumTotal, totalRowRatio } from '../../../../../../react-table/helpers/rowTotals';

export default (data) => {
  const {
    NonZeroNumberColumn,
    NonZeroPercentageColumn,
    TextColumn,
  } = columns(data);
  return [
    {
      Header: 'IMPC',
      columns: [
        new TextColumn('Origin', 'impc.origin')
          .withWidth(100)
          .withTotalHeader('Total'),
        new TextColumn('Destination', 'impc.destination')
          .withWidth(100),
      ],
    },
    {
      Header: 'Receptacles',
      columns: [
        new NonZeroNumberColumn('PREDES', 'receptacles.predesCount')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('PRECON', 'receptacles.preconCount')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('MRD POD', 'receptacles.mrdPodCount')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('RESCON', 'receptacles.resconCount')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('RESDES', 'receptacles.resdesCount')
          .withTotalHeader(sumTotal),
        new NonZeroNumberColumn('MRD POD target', 'receptacles.mrdPodTargetCount')
          .withTotalHeader(sumTotal),
      ],
    },
    {
      Header: 'Ratio %',
      columns: [
        new NonZeroPercentageColumn('MRD POD / RESDES', 'ratio.mrdPodPerPredes')
          .withTotalHeader(totalRowRatio(['receptacles.mrdPodCount', 'receptacles.resdesCount'])),
        new NonZeroPercentageColumn('PRECON / PREDES', 'ratio.preconPerPredes')
          .withTotalHeader(totalRowRatio(['receptacles.preconCount', 'receptacles.predesCount'])),
        new NonZeroPercentageColumn('RESDES / PREDES', 'ratio.resdesPerPredes')
          .withTotalHeader(totalRowRatio(['receptacles.resdesCount', 'receptacles.predesCount'])),
        new NonZeroPercentageColumn('MRD POD / MRD POD target', 'ratio.mrdPodPerMrdPodTarget')
          .withTotalHeader(totalRowRatio(['receptacles.mrdPodCount', 'receptacles.mrdPodTargetCount'])),
      ],
    },
  ];
};
